import axios, { AxiosPromise } from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import { AuthInterceptorRequestFullfiled } from 'src/services/interceptors/request'
import {
  INormalizeResponse,
  NormalizeInterceptorResponseFullfiled,
  ErrorProcessing,
} from 'src/services/interceptors/response'
import * as locationService from 'src/services/location'

const partner = locationService.getPartner()
const project = locationService.getProject()
const domain = window.settings.BASE_SEARCH_DOMAIN

export const baseURL = `//${partner}.${domain}/api/v1`

export type IResponse<data> = INormalizeResponse<data>
export type HTTPPromise<Data> = AxiosPromise<Data>

export const http = axios.create({
  baseURL,
  withCredentials: false,
})

applyCaseMiddleware(http)
http.interceptors.response.use(
  NormalizeInterceptorResponseFullfiled,
  ErrorProcessing
)
http.interceptors.request.use(AuthInterceptorRequestFullfiled)
http.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    project,
  }

  return config
})
